import ModalFormFieldTypes from '@/common/components/controls/modal/ModalFormFieldTypes';
import Exception from '@/common/models/Exception';
import { generateUUID } from '@/globals';

export default class ModalFormField {
  constructor({
    id,
    name,
    caption,
    inputType,
    value,
    description,
    options, // drop down options, should be a list of objects with id and name.,
    isMandatory,
  }) {
    this.id = id || generateUUID();
    this.name = name;
    this.caption = caption;
    this.inputType = inputType;
    this.value = value;
    this.description = description;
    this.options = options;
    this.isMandatory = isMandatory;
    this.overridenValue = null;

    //
    // Validation
    //
    if (this.name == null || this.name.trim() === '') {
      throw new Exception('Form field name is required.');
    }
    if (this.caption == null || this.caption.trim() === '') {
      throw new Exception('Form field caption is required.');
    }

    switch (this.inputType) {
      case ModalFormFieldTypes.multiSelect:
      case ModalFormFieldTypes.singleSelect: {
        if (this.options == null) {
          throw new Exception('You need to supply a list of options when using a single/multi select form field.');
        }
        if (this.value == null) {
          this.value = [];
        }
        break;
      }
      case ModalFormFieldTypes.tabSlider: {
        if (this.options == null || this.options.length !== 2) {
          throw new Exception('You need to supply a list of two options for a tab slider form field.');
        }
        if (this.value == null) {
          this.value = this.options[0].id;
        }
        break;
      }
      default:
        break;
    }
  }
}
